import versionMetadata from './currentVersion.json';

export default versionMetadata.version;
